import { z } from "zod";
import { clampedLimit } from "./common.schema";
import { EventSubscriptionFilterSchema } from "./event-subscription.schema";

// ADV-920: Replay activity_events through the dispatcher.
//
// One of `since` (ISO timestamp) or `since_event_id` (UUID) MUST be set —
// validated at the service layer. The optional `filter` overlay lets callers
// narrow the replay further than the subscription's stored filter.

export const EventReplayRequestSchema = z.object({
  subscription_id: z.string().uuid().describe("Subscription"),
  since: z.string().datetime().optional().describe("Since (ISO Timestamp)"),
  // schema-check-ignore: query-filter — replay cursor, null/"" semantically distinct from "no cursor"
  since_event_id: z.string().uuid().optional().describe("Since Event"),
  filter: EventSubscriptionFilterSchema.optional().describe(
    "Replay Filter (overlay)",
  ),
  limit: clampedLimit(1000, 100).describe("Limit"),
});

export type EventReplayRequest = z.input<typeof EventReplayRequestSchema>;

export const EventReplayResponseSchema = z.object({
  replayed_count: z.number().int().describe("Replayed Count"),
  last_event_id: z.string().uuid().nullable().describe("Last Event"),
});

export type EventReplayResponse = z.infer<typeof EventReplayResponseSchema>;
